export const calculateProgressBeforeCheckout = (pageNum, total) => {
  const current = pageNum + 1;
  const progress = (current / total) * 50;
  return progress;
};

export const calculateProgressAfterCheckout = (pageNum, total) => {
  const current = pageNum;
  const progress = (current / total) * 50 + 50;
  return progress;
};
